export const Types = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    SELECT_CUSTOMER: 'SELECT_CUSTOMER',
    SELECT_SALE: 'SELECT_SALE'
  }